import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxBarcodeModule } from 'src/app/services/ngx-barcode/ngx-barcode.module';
import { CustomDatePickerModule } from '../custom-date-picker/custom-date-picker.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingAnimationModule } from "../loading-animation/loading-animation.module";
import { MatPaginatorIntl, MatPaginatorModule } from "@angular/material/paginator";
import { MatChipsModule } from "@angular/material/chips";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatInputModule } from "@angular/material/input";
import {  MatToolbarModule } from "@angular/material/toolbar";
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from "@angular/material/icon";
import {MatSortModule} from '@angular/material/sort';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { provideTablerIcons, TablerIconComponent } from 'angular-tabler-icons';
import {
  IconCopy,
  IconPencil,
  IconTrash
} from 'angular-tabler-icons/icons';
import { CustomMatPaginatorIntl } from './custom-mat-paginator-intl';
import { CdkColumnDef } from '@angular/cdk/table';
import { NgxCurrencyDirective } from 'ngx-currency';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomGridComponent } from './custom-grid.component';
import { CustomDropDownListModule } from '../custom-drop-down-list/custom-drop-down-list.module';

@NgModule({
  declarations: [
    CustomGridComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingAnimationModule,
    MatPaginatorModule,
    MatChipsModule,
    MatCheckboxModule,
    MatInputModule,
    MatToolbarModule,
    MatTableModule,
    MatIconModule,
    MatSortModule ,
    MatSlideToggleModule,
    TablerIconComponent,
    NgxCurrencyDirective,
    MatTooltipModule,
    NgxBarcodeModule,
    CustomDatePickerModule,
    CustomDropDownListModule
],
  exports: [
    CustomGridComponent
  ],
  providers: [
    provideTablerIcons({IconPencil,IconTrash,IconCopy}),
    {
      provide: MatPaginatorIntl, 
      useClass: CustomMatPaginatorIntl
    },
    CdkColumnDef
  ]
})
export class CustomGridModule { }
